// frontend/src/index.js

// --- 1. ИМПОРТЫ ---
// Импортируем основные библиотеки для работы с React.
import React from 'react';
import ReactDOM from 'react-dom/client'; // Современный API для рендеринга в DOM

// Импортируем глобальные стили, которые будут применяться ко всему приложению.
import './styles/index.css';
import './styles/fitenko-tokens.css';
// Оболочка арендатора fitenko: колонка --rail-w и поднятая полоса --topbar-h.
// 🔴 Импорт СТРОГО после токенов — иначе var(--rail-w) читался бы до объявления.
import './styles/fitenko-shell.css';
// Применение шрифтовых токенов §3.1 к оболочке fitenko (окно 3).
import './styles/fitenko-type.css';
// Единая дизайн-система (§I.1): импортируется ПОСЛЕДНЕЙ, чтобы побеждать в каскаде
import './styles/tokens.css';

// Импортируем главный компонент приложения, который содержит всю остальную логику.
import App from './App';

// --- 2. ИНИЦИАЛИЗАЦИЯ ПРИЛОЖЕНИЯ ---
// Находим корневой DOM-элемент в public/index.html (обычно это <div id="root"></div>).
// В этот элемент React будет "монтировать" все наше приложение.
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

// --- 3. РЕНДЕРИНГ ПРИЛОЖЕНИЯ ---
// Метод .render() "оживляет" наше приложение, вставляя компонент App в корневой DOM-элемент.
root.render(
  // <React.StrictMode> - это специальный инструмент для разработки.
  // Он не влияет на финальную сборку (production build), но в режиме разработки
  // помогает находить потенциальные проблемы, такие как устаревшие методы или небезопасные практики.
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
